<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/2YyWbc/images/img1.jpg?1685327424733" alt="This image is the cover for the book Long, Lonely Howl"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Long, Lonely Howl
      </h1>
      <p class="bookDescription body article font2">
        <p>Although Casey Keller loves his life as a YMCA counselor, making a difference in the lives of inner-city kids, his personal life is a mess. He loves Adam, his live-in boyfriend, but he can't deal with him. He misses Nathan, an old lover and current friend, but there's a distance between them Casey can't overcome. He’s starting to fear that he's the one constantly ruining any chance he has for happiness. But life is about to change: a trip to the California mountains to escape the pressures of city life will introduce him to a world he never knew existed, where creatures out of mythology and fiction roam and men run in packs.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Lyn Gala
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?81b77330